// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1_H9Z","bigColWidth":"Table_bigColWidth__2zKKf","biggerColWidth":"Table_biggerColWidth__2iY8K","row":"Table_row__3ITyt","col":"Table_col__23wlM"};